import { render, staticRenderFns } from "./whatsapp-plus.vue?vue&type=template&id=030ac926&scoped=true"
import script from "./whatsapp-plus.vue?vue&type=script&lang=js"
export * from "./whatsapp-plus.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-plus.vue?vue&type=style&index=0&id=030ac926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030ac926",
  null
  
)

export default component.exports